import React from 'react';

// component
import Header from 'components/Header';
import Footer from 'components/Footer';
import useWindowSize from 'utils/useWindowSize';

export default function HomeLayout({ children }) {
    const { sizes } = useWindowSize();
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    minHeight: '100vh',
                    backgroundColor: "#f5f6fa",
                }}
            >
                <main>
                    <Header />
                    <div style={{ flexGrow: 1, marginTop: 110 }}>{children}</div>
                    <Footer />
                </main>
            </div>
        </>
    );
}
